// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background: #0A0A1B;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
}

.navbar-container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  height: 70px;
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 3rem;
}

.brand-info {
  display: flex;
  flex-direction: column;
}

.brand-link {
  text-decoration: none;
  transition: all 0.3s ease;
  outline: none;
}

.brand-link:hover {
  transform: translateY(-1px);
}

.brand-link:focus {
  outline: none;
  box-shadow: none;
}

.brand-logo {
  height: 2.6rem;
  width: auto;
  max-width: 140px;
  object-fit: contain;
  transition: all 0.3s ease;
}

.brand-logo:hover {
  transform: scale(1.05);
}

/* Navigation Links */
.navbar-nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover:not(.disabled) {
  color: white;
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.nav-link.active {
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.3);
}

.nav-link.disabled::after {
  content: 'Soon';
  position: absolute;
  top: -8px;
  right: -8px;
  background: #667eea;
  color: white;
  font-size: 0.6rem;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: 600;
}

/* Navigation Button (for unauthenticated users) */
.nav-button {
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
}

.nav-button:hover {
  color: white;
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

/* Authentication Section */
.navbar-auth {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.auth-loading {
  color: rgba(255, 255, 255, 0.6);
  background: #0A0A1B;
  padding: 0.5rem 1rem;
  border-radius: 8px;
}

.auth-user {
  position: relative;
  cursor: pointer;
}

.user-avatar-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.user-avatar-section:hover {
  background: rgba(255, 255, 255, 0.1);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #475569 !important;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.avatar-letter {
  color: white;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}

.dropdown-arrow {
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: rgba(30, 30, 40, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1rem;
  min-width: 200px;
  z-index: 1000;
  animation: dropdownFadeIn 0.3s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}



.user-streak-info {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8rem;
}

.streak-icon-small {
  width: 12px;
  height: 12px;
  color: #667eea;
}

.profile-button {
  width: 100%;
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  border: 1px solid rgba(102, 126, 234, 0.3);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-bottom: 0.5rem;
}

.profile-button:hover {
  background: rgba(102, 126, 234, 0.2);
  border-color: rgba(102, 126, 234, 0.5);
  transform: translateY(-1px);
}

.logout-button {
  width: 100%;
  background: rgba(220, 38, 127, 0.1);
  color: #dc267f;
  border: 1px solid rgba(220, 38, 127, 0.3);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.logout-button:hover {
  background: rgba(220, 38, 127, 0.2);
  border-color: rgba(220, 38, 127, 0.5);
  transform: translateY(-1px);
}

.auth-buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.auth-btn {
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  white-space: nowrap;
  min-width: 70px;
  text-align: center;
}

.auth-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-1px);
}

.auth-btn.primary {
  background: rgba(255, 255, 255, 0.2);
  border-color: white;
}

.auth-btn.primary:hover {
  background: white;
  color: #667eea;
}

/* Actions Section */
.navbar-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav-action {
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.1rem;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
}

.nav-action:hover:not(.disabled) {
  color: white;
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.nav-action.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .navbar-container {
    padding: 1rem;
  }
  
  .navbar-left {
    gap: 2rem;
  }
  
  .brand-subtitle {
    display: none;
  }
  
  .navbar-nav {
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .navbar-container {
    padding: 0 1rem;
    gap: 1rem;
  }

  .navbar-left {
    flex-shrink: 0;
  }

  .brand-logo {
    height: 2.2rem;
    max-width: 110px;
  }

  .navbar-nav {
    gap: 1.5rem;
  }

  .nav-link {
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }

  .navbar-auth {
    gap: 0.75rem;
  }

  .auth-buttons {
    gap: 0.5rem;
  }

  .auth-btn {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }

  .user-avatar {
    width: 28px;
    height: 28px;
  }

  .avatar-letter {
    font-size: 12px;
  }

  .dropdown-arrow {
    width: 10px;
    height: 10px;
  }
}

@media (max-width: 640px) {
  .navbar-container {
    padding: 0 0.75rem;
    gap: 0.75rem;
  }

  .navbar-left {
    min-width: auto;
  }

  .brand-logo {
    height: 2rem;
    max-width: 100px;
  }

  .navbar-nav {
    gap: 1rem;
  }

  .nav-link {
    font-size: 0.85rem;
    padding: 0.35rem 0.7rem;
  }

  .auth-buttons {
    gap: 0.4rem;
  }

  .auth-btn {
    padding: 0.45rem 0.9rem;
    font-size: 0.8rem;
  }

  .user-avatar {
    width: 26px;
    height: 26px;
  }

  .avatar-letter {
    font-size: 11px;
  }

  .user-dropdown {
    min-width: 180px;
    padding: 0.8rem;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    padding: 0 0.5rem;
  }

  .brand-logo {
    height: 1.8rem;
    max-width: 90px;
  }

  .navbar-nav {
    gap: 0.75rem;
  }

  .nav-link {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
  }

  .auth-buttons {
    gap: 0.3rem;
  }

  .auth-btn {
    padding: 0.4rem 0.8rem;
    font-size: 0.75rem;
  }

  .user-avatar {
    width: 24px;
    height: 24px;
  }

  .avatar-letter {
    font-size: 10px;
  }
}

@media (max-width: 380px) {
  .navbar-container {
    padding: 0 0.4rem;
  }

  .brand-logo {
    height: 1.6rem;
    max-width: 80px;
  }

  .nav-link {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
  }

  .navbar-nav {
    gap: 0.5rem;
  }

  .auth-buttons {
    gap: 0.25rem;
  }

  .auth-btn {
    padding: 0.35rem 0.7rem;
    font-size: 0.7rem;
  }

  .user-avatar {
    width: 22px;
    height: 22px;
  }

  .avatar-letter {
    font-size: 9px;
  }

  .user-dropdown {
    min-width: 160px;
    padding: 0.6rem;
  }
}

.navbar .user-avatar {
  background: #475569 !important;
}

.auth-user .user-avatar {
  background: #475569 !important;
}

.user-avatar-section .user-avatar {
  background: #475569 !important;
}

.brand-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.3s ease;
}

`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,UAAU;EACV,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,cAAc;EACd,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B","sourcesContent":[".navbar {\n  background: #0A0A1B;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 0;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  backdrop-filter: blur(10px);\n}\n\n.navbar-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 2rem;\n  height: 70px;\n}\n\n.navbar-left {\n  display: flex;\n  align-items: center;\n  gap: 3rem;\n}\n\n.brand-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.brand-link {\n  text-decoration: none;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.brand-link:hover {\n  transform: translateY(-1px);\n}\n\n.brand-link:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.brand-logo {\n  height: 2.6rem;\n  width: auto;\n  max-width: 140px;\n  object-fit: contain;\n  transition: all 0.3s ease;\n}\n\n.brand-logo:hover {\n  transform: scale(1.05);\n}\n\n/* Navigation Links */\n.navbar-nav {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.nav-link {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 1rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.nav-link:hover:not(.disabled) {\n  color: white;\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-1px);\n}\n\n.nav-link.active {\n  color: #667eea;\n  background: rgba(102, 126, 234, 0.1);\n  border: 1px solid rgba(102, 126, 234, 0.3);\n}\n\n.nav-link.disabled::after {\n  content: 'Soon';\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background: #667eea;\n  color: white;\n  font-size: 0.6rem;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-weight: 600;\n}\n\n/* Navigation Button (for unauthenticated users) */\n.nav-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 1rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.nav-button:hover {\n  color: white;\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-1px);\n}\n\n/* Authentication Section */\n.navbar-auth {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.auth-loading {\n  color: rgba(255, 255, 255, 0.6);\n  background: #0A0A1B;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n}\n\n.auth-user {\n  position: relative;\n  cursor: pointer;\n}\n\n.user-avatar-section {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.25rem;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n}\n\n.user-avatar-section:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #475569 !important;\n}\n\n.avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.avatar-letter {\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  text-align: center;\n}\n\n.dropdown-arrow {\n  color: rgba(255, 255, 255, 0.7);\n  display: flex;\n  align-items: center;\n  transition: transform 0.3s ease;\n}\n\n.dropdown-arrow.open {\n  transform: rotate(180deg);\n}\n\n.user-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 0.5rem;\n  background: rgba(30, 30, 40, 0.95);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1rem;\n  min-width: 200px;\n  z-index: 1000;\n  animation: dropdownFadeIn 0.3s ease;\n}\n\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n\n.user-streak-info {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.8rem;\n}\n\n.streak-icon-small {\n  width: 12px;\n  height: 12px;\n  color: #667eea;\n}\n\n.profile-button {\n  width: 100%;\n  background: rgba(102, 126, 234, 0.1);\n  color: #667eea;\n  border: 1px solid rgba(102, 126, 234, 0.3);\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  margin-bottom: 0.5rem;\n}\n\n.profile-button:hover {\n  background: rgba(102, 126, 234, 0.2);\n  border-color: rgba(102, 126, 234, 0.5);\n  transform: translateY(-1px);\n}\n\n.logout-button {\n  width: 100%;\n  background: rgba(220, 38, 127, 0.1);\n  color: #dc267f;\n  border: 1px solid rgba(220, 38, 127, 0.3);\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.logout-button:hover {\n  background: rgba(220, 38, 127, 0.2);\n  border-color: rgba(220, 38, 127, 0.5);\n  transform: translateY(-1px);\n}\n\n.auth-buttons {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.auth-btn {\n  background: transparent;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  padding: 8px 16px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white;\n  white-space: nowrap;\n  min-width: 70px;\n  text-align: center;\n}\n\n.auth-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-1px);\n}\n\n.auth-btn.primary {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: white;\n}\n\n.auth-btn.primary:hover {\n  background: white;\n  color: #667eea;\n}\n\n/* Actions Section */\n.navbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.nav-action {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 1.1rem;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.nav-action:hover:not(.disabled) {\n  color: white;\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-1px);\n}\n\n.nav-action.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .navbar-container {\n    padding: 1rem;\n  }\n  \n  .navbar-left {\n    gap: 2rem;\n  }\n  \n  .brand-subtitle {\n    display: none;\n  }\n  \n  .navbar-nav {\n    gap: 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .navbar-container {\n    padding: 0 1rem;\n    gap: 1rem;\n  }\n\n  .navbar-left {\n    flex-shrink: 0;\n  }\n\n  .brand-logo {\n    height: 2.2rem;\n    max-width: 110px;\n  }\n\n  .navbar-nav {\n    gap: 1.5rem;\n  }\n\n  .nav-link {\n    font-size: 0.9rem;\n    padding: 0.4rem 0.8rem;\n  }\n\n  .navbar-auth {\n    gap: 0.75rem;\n  }\n\n  .auth-buttons {\n    gap: 0.5rem;\n  }\n\n  .auth-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  .user-avatar {\n    width: 28px;\n    height: 28px;\n  }\n\n  .avatar-letter {\n    font-size: 12px;\n  }\n\n  .dropdown-arrow {\n    width: 10px;\n    height: 10px;\n  }\n}\n\n@media (max-width: 640px) {\n  .navbar-container {\n    padding: 0 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .navbar-left {\n    min-width: auto;\n  }\n\n  .brand-logo {\n    height: 2rem;\n    max-width: 100px;\n  }\n\n  .navbar-nav {\n    gap: 1rem;\n  }\n\n  .nav-link {\n    font-size: 0.85rem;\n    padding: 0.35rem 0.7rem;\n  }\n\n  .auth-buttons {\n    gap: 0.4rem;\n  }\n\n  .auth-btn {\n    padding: 0.45rem 0.9rem;\n    font-size: 0.8rem;\n  }\n\n  .user-avatar {\n    width: 26px;\n    height: 26px;\n  }\n\n  .avatar-letter {\n    font-size: 11px;\n  }\n\n  .user-dropdown {\n    min-width: 180px;\n    padding: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .navbar-container {\n    padding: 0 0.5rem;\n  }\n\n  .brand-logo {\n    height: 1.8rem;\n    max-width: 90px;\n  }\n\n  .navbar-nav {\n    gap: 0.75rem;\n  }\n\n  .nav-link {\n    font-size: 0.8rem;\n    padding: 0.3rem 0.6rem;\n  }\n\n  .auth-buttons {\n    gap: 0.3rem;\n  }\n\n  .auth-btn {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.75rem;\n  }\n\n  .user-avatar {\n    width: 24px;\n    height: 24px;\n  }\n\n  .avatar-letter {\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 380px) {\n  .navbar-container {\n    padding: 0 0.4rem;\n  }\n\n  .brand-logo {\n    height: 1.6rem;\n    max-width: 80px;\n  }\n\n  .nav-link {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n  }\n\n  .navbar-nav {\n    gap: 0.5rem;\n  }\n\n  .auth-buttons {\n    gap: 0.25rem;\n  }\n\n  .auth-btn {\n    padding: 0.35rem 0.7rem;\n    font-size: 0.7rem;\n  }\n\n  .user-avatar {\n    width: 22px;\n    height: 22px;\n  }\n\n  .avatar-letter {\n    font-size: 9px;\n  }\n\n  .user-dropdown {\n    min-width: 160px;\n    padding: 0.6rem;\n  }\n}\n\n.navbar .user-avatar {\n  background: #475569 !important;\n}\n\n.auth-user .user-avatar {\n  background: #475569 !important;\n}\n\n.user-avatar-section .user-avatar {\n  background: #475569 !important;\n}\n\n.brand-content {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  transition: all 0.3s ease;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
